module.exports = "/_next/static/images/687bb33fe679630f48d4bc7176020ef3-debit-phase-5.svg";